/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M256.524 45.05c-116.601 0-211.437 94.863-211.437 211.437 0 116.573 94.836 211.437 211.437 211.437 116.602 0 211.438-94.863 211.438-211.437 0-116.574-94.836-211.438-211.438-211.438zm0 465.111C116.636 510.161 2.85 396.375 2.85 256.487c0-139.86 113.786-253.675 253.674-253.675 139.889 0 253.675 113.815 253.675 253.675 0 139.888-113.786 253.674-253.675 253.674zM328.9 365.635a21.092 21.092 0 01-14.192-5.462l-89.43-81.039c-4.392-3.998-6.926-9.686-6.926-15.627V158.534c0-11.657 9.46-21.118 21.118-21.118 11.658 0 21.119 9.46 21.119 21.118v95.596l82.502 74.731c8.645 7.828 9.292 21.203 1.464 29.82-4.167 4.617-9.911 6.954-15.655 6.954z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconClock = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconClock.defaultProps = {
  theme,
};
IconClock.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconClock.displayName = 'IconClock';
export { IconClock };
